import {
    SECRETARY_POST_FAILURE,
    SECRETARY_POST_REQUEST,
    SECRETARY_POST_SUCCESS,
} from 'actions';

const initialState = {
    posting: false,
    hasErrors: false,
};

export default (state = initialState, action) => {
    const {type, secretary} = action;
    switch (type) {
        case SECRETARY_POST_SUCCESS: {return {
            ...initialState,
            secretary,
        }}

        case SECRETARY_POST_REQUEST: {return {
            ...initialState,
            posting: true,
        }}

        case SECRETARY_POST_FAILURE: {return {
            ...initialState,
            posting: false,
            hasErrors: true,
        }}

        default: {return state}
    }
};
